export default "__VITE_ASSET__kKGRKDyp__"